import { AxiosResponse } from 'axios'
import { API } from '../config'
import { GetReportDto, ProcessReportDto, ReportResponseDto } from 'src/dto/report.dto'

const BASE_URL = '/relatorio'

export class ReportService {
  public async getReport(username: string, idRelatorio: string): Promise<AxiosResponse<ReportResponseDto>> {
    return await API.get<ReportResponseDto>(`${BASE_URL}/`, {
      params: {
        username,
        idRelatorio
      }
    })
  }

  public async processReport(farmId: string, processReportDto: ProcessReportDto): Promise<AxiosResponse<GetReportDto>> {
    return await API.post(`${BASE_URL}/${farmId}`, processReportDto)
  }
}
